"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.http = void 0;
const axios_1 = require("axios");
var HttpMethods;
(function (HttpMethods) {
    HttpMethods["GET"] = "get";
    HttpMethods["HEAD"] = "head";
    HttpMethods["POST"] = "post";
    HttpMethods["PUT"] = "put";
    HttpMethods["PATCH"] = "patch";
    HttpMethods["DELETE"] = "delete";
    HttpMethods["OPTIONS"] = "options";
})(HttpMethods || (HttpMethods = {}));
const httpMethodsFactory = (request) => ({
    get: (url, params = {}, opts = {}) => request(Object.assign(Object.assign({}, opts), { url, params, method: HttpMethods.GET })),
    head: (url, params = {}, opts = {}) => request(Object.assign(Object.assign({}, opts), { url, params, method: HttpMethods.HEAD })),
    post: (url, data = {}, opts = {}) => request(Object.assign(Object.assign({}, opts), { url, data, method: HttpMethods.POST })),
    put: (url, data, opts = {}) => request(Object.assign(Object.assign({}, opts), { url, data, method: HttpMethods.PUT })),
    patch: (url, data, opts = {}) => request(Object.assign(Object.assign({}, opts), { url, data, method: HttpMethods.PATCH })),
    delete: (url, opts = {}) => request(Object.assign(Object.assign({}, opts), { url, method: HttpMethods.DELETE }))
});
function http() {
    const xhr = axios_1.default.create();
    const makeRequest = (config) => xhr.request(config).then((response) => response.data);
    const setBaseUrl = (url) => (xhr.defaults.baseURL = url);
    const setHeaders = (headers) => (xhr.defaults.headers = Object.assign(Object.assign({}, xhr.defaults.headers), headers));
    const addRequestInterceptor = (fn) => xhr.interceptors.request.use(fn);
    return Object.assign({ setBaseUrl,
        setHeaders,
        addRequestInterceptor }, httpMethodsFactory(makeRequest));
}
exports.http = http;
//# sourceMappingURL=http.js.map